import * as React from 'react';
import * as ReactDom from 'react-dom';
import { PrimaryButton } from "office-ui-fabric-react/lib/Button";
import { Link } from 'office-ui-fabric-react/lib/Link';
import { containerStyle, logStyle } from "./Account.Style";



import { READER } from '../common/consts';


const  renderLogin = (handleLogin) => {
        return(
            <div style = {containerStyle}>  
            <div style={logStyle}>Push to login using your Micrsoft 365 credentials</div>
            <div style={logStyle}>The application will sign in on your behalf as a user </div>
            <div style={logStyle}>
            <PrimaryButton  onClick={handleLogin}>Login</PrimaryButton>
            </div>
            <div style={logStyle}>By signing in you confirm that you agree in full to :
            <ul>
                <li><a href={READER.TERMS} target="_blank">Terms of Use</a></li>
                <li><a href={READER.PRIVACY} target="_blank">Privacy Policy</a></li>
                <li><a href={READER.PRIVACY} target="_blank">Cookie Policy</a></li> 
            </ul>
            </div>
            <div style={logStyle}>For more information about the product go to :
            <ul>
                <li><a href={READER.ABOUT} target="_blank">About</a></li>
                <li><a href={READER.USER_GUIDE} target="_blank">User Guide</a></li>
                <li><a href={READER.BLOG} target="_blank">Blog</a></li> 
            </ul>
            </div>
            <div style={logStyle}>For further service requests go to :
            <ul>
                <li><a href={READER.SUPPORT} target="_blank">Support</a></li>
            </ul>
            </div>
            <div style={logStyle}>To support by donation :
            <ul>
                <li><a href="https://www.buymeacoffee.com/6WONjZKSz" target="_blank">Click to Buy Me a Coffee!!</a></li>
            </ul>
            </div>

        </div>
    )
    }

    const  renderLogout = (handleLogout) => {
        return(
            <div style = {containerStyle}>  
            <div style={logStyle}>Push to sign out using your Micrsoft 365 logout process </div>
            <div style={logStyle}>The application will sign out on your behalf as a user </div>
            <div style={logStyle}>
            <PrimaryButton  onClick={handleLogout}>Sign out</PrimaryButton>
            </div>
            <div style={logStyle}> You will have to confirm Sign Out and select the Microsoft account to signout. </div>
            <div style={logStyle}> Thank you for using this application !
            </div>
        </div>
    )
    }

export  const Account = ( {accessToken, handleLogin, handleLogout, isAuthenticated})=>{
    return isAuthenticated ? renderLogout(handleLogout) : renderLogin(handleLogin)  
}
